import {Component} from '@angular/core';
import {ActivatedRoute} from '@angular/router';
import {ERROR_PARAM, ERROR_REQUEST_ID_PARAM, parseUUID, RouterService} from '@npck/libs/commons';
import {Error} from '../../infra/app-error-handler.service';

const ERROR_ICONS: Record<string, string> = {
    [Error.PAGE_NOT_FOUND]: 'ic_404',
    [Error.SERVER_ERROR]: 'ic_500',
    [Error.NETWORK_CONNECTIVITY_ERROR]: 'ic_error_no_network',
    [Error.BAD_REQUEST]: 'ic_error',
};

@Component({
    templateUrl: 'error.component.html',
    styleUrls: ['error.component.scss'],
    standalone: false
})
export class ErrorComponent {
    requestId: string;
    errorTitle: string;
    errorSubtitle: string;
    errorIcon: string;
    error: any;

    protected readonly Error = Error;

    constructor(
        private activatedRoute: ActivatedRoute,
        private routerService: RouterService,
    ) {
        const errorFromData = this.activatedRoute.snapshot.data.error;
        const errorFromState = this.routerService.getState<Error>(ERROR_PARAM);
        const errorFromQueryParam = this.activatedRoute.snapshot.queryParams[ERROR_PARAM];
        this.error = errorFromData || errorFromState || errorFromQueryParam || Error.SERVER_ERROR;

        this.requestId = parseUUID(this.activatedRoute.snapshot.queryParams[ERROR_REQUEST_ID_PARAM]);
        this.errorTitle = 'i18n_af_appErrorTitle#' + this.error;
        this.errorSubtitle = 'i18n_af_appErrorSubtitle#' + this.error;
        this.errorIcon = ERROR_ICONS[this.error] || 'ic_error';
    }

    retry(): void {
        this.routerService.navigate(this.routerService.getPreviousUrl());
    }
}
